module.exports = __webpack_public_path__ + "static/media/memory_intro_bird_spritesheet.30679e9d.png";